export const TELCELL_PLACEHOLDER = '78059563';
